import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import './_header.scss';
import SearchBar from '../../mweb/SearchBar/SearchBar';
import Icon from '../../mweb/Icon/Icon';
import { Link } from 'react-router-dom';
import Offers from 'components/web-feature/account/Offers';
import history from 'hb-redux-store/history';
import Badge from '../../mweb/Badge/Badge';
import { getItem } from '../../../hb-redux-store/util/localStorageService';
import LocationNav from 'components/web/LocationNav/LocationNav';
import { showLocationSearchModal } from 'hb-redux-store/feature/modal/modal.action';
import Notifications from 'components/web-feature/account/Notifications';

const HeaderComponent = props => {
  const {
    launchInfo,
    cartQty,
    showLocationSearchModal,
    location,
    notifications,
  } = props;
  const [tabName, setTabName] = useState(''),
    [showOffers, setShowOffers] = useState(false),
    [showNotifications, setNotifications] = useState(false),
    [state, setState] = useState({
      primaryText: 'Home',
      secondaryText: 'Select your address to serve you better',
      showPopover: false,
    });
  const headerLogos = [
    {
      imageclass: 'icon-location-bar-offers cursor-hover',
      title: 'OFFERS',
      hasBadge: false,
      className: '',
    },
    {
      imageclass: 'icon-location-bar-bell cursor-hover',
      title: 'NOTIFICATION',
      hasBadge: true,
      badgeProp: notifications?.notificationsCount || 0,
      className: '',
    },
    {
      imageclass: 'icon-nav-bar-account cursor-hover',
      title: 'USER',
      hasBadge: false,
      url: '/my/details',
      className: 'header-image--title-username',
    },
    {
      imageclass: 'icon-back-bar-cart cursor-hover',
      title: 'CART',
      hasBadge: true,
      badgeProp: cartQty || 0,
      url: '/cart',
      className: '',
    },
  ];

  useEffect(() => {
    const locationDetails = getItem('selectedAddress') || { showPopover: true };
    const {
      primaryText = state.area,
      secondaryText = state.secondaryText,
      showPopover = state.showPopover,
    } = locationDetails;
    setState({ ...state, primaryText, secondaryText, showPopover });
    if (
      location?.pathname.indexOf('/my/') === 0 ||
      location?.pathname.indexOf('/help/') === 0
    ) {
      setTabName('USER');
    } else {
      setTabName('');
    }
  }, []);

  const onTabSelect = tabName => {
    setTabName(tabName);
    switch (tabName) {
      case 'OFFERS':
        onShowOffers(true);
        break;
      case 'NOTIFICATION':
        onShowNotifications(true);
        break;

      default:
        break;
    }
  };

  const onShowNotifications = isNotification => {
    !isNotification && setTabName('');
    setNotifications(isNotification);
  };
  const onShowOffers = isShowOffer => {
    !isShowOffer && setTabName('');
    setShowOffers(isShowOffer);
  };

  const onPopoverSelect = () => {
    showLocationSearchModal({
      locationSearchModal: true,
      typeOfCTA: 'location',
    });
  };

  // const showModalCallback = isShowLocation => {
  //   showLocationSearchModal(isShowLocation);
  // };
  const logoAltTxt =
    'Get Grade A quality Fruits, Nuts, Vegetables & Early Morning Delivery @ VegXL';
  return (
    <Fragment>
      <div className="header-container">
        <div className="header-container--main">
          <Link to="/" onClick={() => setTabName('')}>
            <img
              className="header-image--logo"
              alt={logoAltTxt}
              src={require('../../../assets/icons/icon-halalbox-navbar.svg')}
            />
          </Link>
          {launchInfo && (
            <div onClick={onPopoverSelect} className="cursor-hover">
              <LocationNav launchInfo={launchInfo} tabName={tabName} />
            </div>
          )}
          <div className="header-container--main--searchbar">
            <SearchBar placeHolder="Search for fruits, dry-fruits.. " />
          </div>
          {headerLogos.map((logo, index) => (
            <Link
              to={`${
                ['USER', 'CART'].includes(logo.title) ? `${logo.url}` : '#'
              }`}
              key={index}
              className="header-image cursor-hover"
              onClick={() => onTabSelect(logo.title)}
            >
              <Icon size={24} class={logo.imageclass} />
              {logo.hasBadge && logo.badgeProp > 0 && (
                <div className="header-image--icon-badge">
                  <Badge text={logo.badgeProp} />
                </div>
              )}
              <div
                className={`header-image--title ${logo.className} ${
                  logo.hasBadge && logo.badgeProp > 0
                    ? 'header-image--title-higlight'
                    : ''
                }`}
              >
                {logo.title === 'USER' && launchInfo?.customerFullName
                  ? launchInfo?.customerFullName.split(' ')[0].toUpperCase()
                  : logo.title}
              </div>
            </Link>
          ))}
        </div>
      </div>
      {showOffers && (
        <Offers onShowOffers={onShowOffers} showOffers={showOffers} />
      )}
      {showNotifications && (
        <Notifications
          onShowNotifications={onShowNotifications}
          showNotifications={showNotifications}
        />
      )}
    </Fragment>
  );
};
HeaderComponent.propTypes = {};

const mapStateToProps = rootReducer => ({
  launchInfo: rootReducer.initialReducer.launchInfo,
  cartQty: rootReducer.cartReducer.cartQtyCount,
  notifications: rootReducer.notificationReducer.notifications,
});
const mapDispactchToProps = { showLocationSearchModal };

export default connect(mapStateToProps, mapDispactchToProps)(HeaderComponent);
